(function (scrollLock, Flickity, themeCurrency, Ajaxinate, AOS) {

    var gorgiaChathtml = '';
    //   'use strict';
    jQuery(document).ready(function () {

        // Add Next/Prev Button to Top bar slider
        // if (jQuery('.top-bar__slider-inner').length > 0){
        //     var flktyTopBar = new Flickity('.top-bar__slider-inner .top-bar__slider.type-slider');
        //     jQuery('.top-bar__slider-inner .next').click(function(){
        //         console.log('next');
        //         flktyTopBar.next();
        //     });
        //     jQuery('.top-bar__slider-inner .prev').click(function(){
        //         flktyTopBar.previous();
        //         console.log('prev');
        //     });
        // }
        //End - Add Next/Prev Button to Top bar slider


        // Add class to check content exist in input search
        jQuery('.search-popdown__main .search-form__input').on('keyup keydown change focus blur paste', function () {
            if (jQuery(this).val() != '') {
                // jQuery(this).parent().addClass('has-content');
                // jQuery('.site-header').addClass('site-header--hovered');
                jQuery('.site-header').addClass('site-header--search-opened');
            } else {
                // jQuery(this).parent().removeClass('has-content');
                // jQuery('.site-header').removeClass('site-header--hovered');
                jQuery('.site-header').removeClass('site-header--search-opened');
            }
        });
        //End - Add class to check content exist in input search

        jQuery('.search-popdown__toggle').click(function () {
            jQuery('.site-header').toggleClass('site-header--search-opened');
            jQuery('.search-popdown__main .search-form__input').val('').trigger('change');
            if (jQuery('search-popdown.search-popdown.menu__item predictive-search').attr('results') == false) {
                jQuery('search-popdown.search-popdown.menu__item predictive-search').attr('results', true);
            } else {
                jQuery('search-popdown.search-popdown.menu__item predictive-search').attr('results', false);
            }
            if (jQuery('search-popdown.search-popdown.menu__item predictive-search').attr('results') == false) {
                jQuery('search-popdown.search-popdown.menu__item predictive-search').attr('open', true);
            } else {
                jQuery('search-popdown.search-popdown.menu__item predictive-search').attr('open', false);
            }
        });

        //Clear search content - header
        jQuery('.search-form__input-holder .search-form__clear, .search-popdown__close').click(function () {
            jQuery('.search-popdown__main .search-form__input').val('').trigger('change');
            jQuery('search-popdown.search-popdown.menu__item predictive-search').attr('results', false).attr('open', false);
            // jQuery('.site-header').removeClass('site-header--hovered');
            jQuery('.site-header').removeClass('site-header--search-opened');
        });
        //End - Clear search content - header


        // jQuery('.newsletter-form [type="submit"]').click(function(event){
        //     let form = jQuery(this).closest('form');
        //     jQuery.ajax({
        //         type: 'POST',
        //         dataType: 'json',
        //         url: form.attr('action'),
        //         data: form.serialize(),
        //         success: function(result){
        //             console.log(result);
        //         }
        //     });
        //     return false;
        // });


    });


    // Move USO tag into product-label-bottom in Collection page
    var moveCollectionLabel = setInterval(function () {
        if (jQuery('.saso-offer-badge-text').length) {
            jQuery('.product-image-container').each(function () {
                if (jQuery(this).find('.product-label-bottom').length && jQuery(this).find('.product-label-bottom .saso-offer-badge-text').length == 0) {
                    let sasoHtml = jQuery(this).find('.saso-offer-badge-text').clone(true);
                    jQuery(this).find('.product-label-bottom').append(sasoHtml);
                }
            });
        }
    }, 50);

    setTimeout(function () {
        clearInterval(moveCollectionLabel);
    }, 20000);


    jQuery(window).on('resize orientationchange', function () {
        setFlickityCarouselHeight();
    });



    function setFlickityCarouselHeight() {
        // Check if there are any elements with the class .carousel__item
        if (jQuery('.flickity-viewport .carousel__item').length) {
            var maxHeight = 0;
            jQuery('.flickity-viewport').each(function () {
                // Loop through each .carousel__item element and find the maximum height
                jQuery(this).find('.carousel__item').each(function () {
                    var itemHeight = jQuery(this).outerHeight();
                    if (itemHeight > maxHeight) {
                        maxHeight = itemHeight;
                    }
                });

                // Set the maximum height found to the .flickity-viewport element
                jQuery(this).css('height', maxHeight + 'px');
            })
        }
    }

    // Call the setCarouselHeight function initially
    setFlickityCarouselHeight();

    jQuery(window).on('load', function () {
        setFlickityCarouselHeight();
    });

    //catch button cart__checkout click
    jQuery('.cart__checkout').click(function (e) {
        e.preventDefault();
        var cartCheckButton = jQuery(this);
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            success: function (cartinfo) {
                let outOfStock = [];
                let promises = [];

                // Loop through each item in the cart
                cartinfo.items.forEach(function (item) {
                    let promise = fetchProductMetafields(item.handle).then((metafields) => {
                        if (metafields && metafields.dc_inventory !== undefined) {
                            // Check if the quantity in the cart is greater than the inventory
                            if (item.quantity > metafields.dc_inventory && item.properties._inventory_policy === 'deny') {
                                outOfStock.push(`${item.title} (Available: ${metafields.dc_inventory}) Please remove from your cart to continue.`);
                            }
                        }
                    });
                    promises.push(promise);
                });

                // Wait for all promises to resolve
                Promise.all(promises).then(() => {
                    if (outOfStock.length > 0) {
                        console.log('Not ok: \n' + outOfStock.join('\n'));
                        //show dc_inventory_error as slideToggle and add outOfStock text to it and kepp old text
                        let dcInventoryError = jQuery('.dc_inventory_error');
                        dcInventoryError.slideToggle();
                        //use append to keep old text
                        dcInventoryError.append('<span>' + outOfStock.join('<br>') + '</span>');

                        //Add class disabled to button checkout
                        cartCheckButton.addClass('disabled');
                    } else {
                        console.log('Ok');
                        window.location.href = '/checkout';
                    }
                });
            },
        });
    });

    function fetchProductMetafields(productHandle) {
        return fetch(`/products/${productHandle}?view=dc_inventory`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                // Return an object containing the metafields
                return {
                    dc_inventory: data.dc_inventory || 0,
                };
            })
            .catch((error) => {
                console.error(`Error fetching inventory for ${productHandle}:`, error);
                return null;
            });
    }


})(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.themeCurrency, themeVendor.ajaxinate, themeVendor.AOS);

